import { BaseViewStore } from 'core/stores';
import { PasswordRecoveryChangeForm } from 'modules/membership/forms';
import { action } from 'mobx';
import { notificationError } from 'core/utils';

class PasswordRecoveryChangeViewStore extends BaseViewStore {
	passwordRecoveryChangeForm = new PasswordRecoveryChangeForm({
		onSuccess: async form => {
			const { password } = form.values();
			const passwordRecoveryToken = this.rootStore.routerStore.routerState.queryParams.passwordRecoveryToken;
			await this.changePassword({
				password,
				passwordRecoveryToken,
			});
		},
	});

	constructor(rootStore) {
		super(rootStore);
		this.initialize();
	}

	@action async initialize() {
		this.passwordRecoveryChangeForm.state.options.set({
			validateOnBlur: false,
			showErrorsOnReset: false,
			validateOnChange: true,
		});
	}

	@action.bound async changePassword({ password, passwordRecoveryToken }) {
		this.suspend();

		try {
			await this.rootStore.app.baasic.membershipModule.passwordRecovery.reset({
				newPassword: password,
				passwordRecoveryToken,
			});
			this.rootStore.notificationStore.success('PASSWORDCHANGECONFIRM');
		} catch (err) {
			notificationError({ store: this.rootStore.notificationStore, err });
		}
		this.resume();
	}

	@action.bound async goToLogin() {
		await this.rootStore.routerStore.goTo('master.app.membership.login');
	}
}

export default PasswordRecoveryChangeViewStore;



// WEBPACK FOOTER //
// ./src/modules/membership/stores/PasswordRecoveryChangeViewStore.js